import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Postback} from '../../models/postback/postback';

@Injectable({
  providedIn: 'root'
})
export class PostbackService extends AbstractModelService<Postback> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/postback', Postback);
  }
}
